









































































import { stringifyUrl } from 'query-string';
import debounce from 'debounce-fn';
import cleanDeep from 'clean-deep';
import { URL_API, OPSI_STRINGIFY } from '@/constants';
import { kirimData, unduhKode } from '@/utils';
import {
  defineComponent,
  reactive,
  toRef,
  toRefs,
  watch,
  onMounted,
  ref,
  provide,
  computed,
  nextTick,
} from '@vue/composition-api';
import getOptions from '@/compositions/getOptions';

type State = {
  inputKode: string;
  bahasaPemrogramanTerpilih?: string;
  namaBerkas?: string;
  highlight?: string;
  twoslashTerpilih?: string;
  hasilHighlight?: string;
};

export default defineComponent({
  components: {
    AppEditorKode: () => import('@/components/partial/AppEditorKode.vue'),
    AppEditorPreview: () => import('@/components/partial/AppEditorPreview.vue'),
  },
  setup(_, { root: { $store }, emit }) {
    const scrollX = ref(0);
    const scrollY = ref(0);
    provide('scroll', { scrollX, scrollY });
    const state = reactive<State>({
      inputKode: '',
      bahasaPemrogramanTerpilih: 'javascript',
      namaBerkas: 'Untitled Document',
      highlight: undefined,
      twoslashTerpilih: undefined,
      hasilHighlight: undefined,
    });
    const supportSlash = computed(
      () =>
        state.bahasaPemrogramanTerpilih === 'typescript' ||
        state.bahasaPemrogramanTerpilih === 'json'
    );
    const { load, daftarBahasaPemrograman, daftarTwoslash } = getOptions();

    onMounted(() => {
      load().catch(function(dataNotifikasiGalat) {
        $store.dispatch('notifikasi/tampilkanNotifikasi', dataNotifikasiGalat);
      });
    });

    const objekUrl = (download?: number) => ({
      url: URL_API,
      query: {
        lang: state.bahasaPemrogramanTerpilih,
        fileName: state.namaBerkas,
        highlight: state.highlight,
        twoslash: supportSlash.value ? state.twoslashTerpilih : undefined,
        download,
      },
    });

    async function highlighter(
      state: any,
      inputKode: string,
      download?: number
    ) {
      try {
        $store.dispatch('proses/tampilkanProses', null);

        const url = stringifyUrl(objekUrl(download), OPSI_STRINGIFY);

        const respon = await kirimData(url, {
          code: inputKode,
        });

        if (respon.success && !respon.error) {
          state.hasilHighlight = respon.data;
        } else {
          throw new Error(respon.message);
        }
      } catch (error) {
        const dataNotifikasiGalat = {
          apakahTampil: true,
          pesan: error.message || 'Bahasa Pemrograman dan Kode wajib diisi',
        };
        $store.dispatch('notifikasi/tampilkanNotifikasi', dataNotifikasiGalat);
        console.log(error);
      } finally {
        $store.dispatch('proses/hilangkanProses', null);
      }
    }

    function putMark(marks: number[]) {
      if (state.inputKode) {
        state.highlight = marks.join(',');
      }
    }

    watch(state, (nState, oldState) => {
      if (
        nState.bahasaPemrogramanTerpilih !== oldState.bahasaPemrogramanTerpilih
      ) {
        nextTick(() => (state.inputKode = ''));
        return;
      }
      if (nState.inputKode === oldState.inputKode) {
        highlighter(nState, nState.inputKode);
      }
    });

    async function ketikaTombolUnduhDiKlik() {
      try {
        $store.dispatch('proses/tampilkanProses', null);
        const url = stringifyUrl(objekUrl(1), OPSI_STRINGIFY);
        await unduhKode(url, {
          code: state.inputKode,
        });
      } catch (error) {
        const dataNotifikasiGalat = {
          apakahTampil: true,
          pesan: error.message || 'Gagal mengunduh',
        };
        $store.dispatch('notifikasi/tampilkanNotifikasi', dataNotifikasiGalat);
        console.log(error);
      } finally {
        $store.dispatch('proses/hilangkanProses', null);
      }
    }

    async function ketikaTombolSimpanDiKlik() {
      try {
        const konten = cleanDeep({
          kode: state.inputKode,
          bahasaPemrograman: state.bahasaPemrogramanTerpilih,
          highlight: state.highlight,
          namaBerkas: state.namaBerkas,
          twoslash: state.twoslashTerpilih,
        });
        await $store.dispatch('kode/simpanKode', {
          idPengguna: $store.state.pengguna.idPengguna,
          konten: konten,
        });
        await emit('tersimpan');
      } catch (error) {
        const dataNotifikasiGalat = {
          apakahTampil: true,
          pesan: error.message || 'Gagal menyimpan',
        };
        $store.dispatch('notifikasi/tampilkanNotifikasi', dataNotifikasiGalat);
        console.log(error);
      }
    }

    watch(
      toRef(state, 'inputKode'),
      debounce(
        kode => {
          // state.hasilHighlight = '';
          highlighter(state, kode);
        },
        { wait: 300 }
      )
    );

    return {
      ...toRefs(state),
      daftarBahasaPemrograman,
      daftarTwoslash,
      putMark,
      supportSlash,
      ketikaTombolUnduhDiKlik,
      ketikaTombolSimpanDiKlik,
    };
  },
});
